//import {createSelector} from 'reselect'
import get from 'lodash/get'

export const getDrawerOpen = (state) => get(state, ['site', 'drawerOpen']);
export const getShowMenu = (state) => get(state, ['site', 'showMenu']);
export const getShowHeader = (state) => get(state, ['site', 'showHeader']);
export const getShowFooter = (state) => get(state, ['site', 'showFooter']);
export const getTitle = (state) => {
    var pathname = get(state, ['router', 'location', 'pathname']);
    if(pathname.indexOf('/rfs') >= 0) return "Services"
    if(pathname.indexOf('/connections') >= 0) return "Connections"
    if(pathname.indexOf('/outages') >= 0) return "Outages"

    return ''
}




// WEBPACK FOOTER //
// ./src/selectors/site.js